<template>
    <div class="page-product-guide">
        <div class="jumbo-wrapper product-guide">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">PRODUCT GUIDE</p>
                    <h2 class="t42">
                        BRICKS, TILES &amp;
                        <br/>
                        ENGRAVING OPTIONS
                    </h2>
                    <p class="t20">Our colors and sizes are well-suited for any location.</p>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-inner">
                <div class="row checkbox-list">
                    <div class="col-sm-6 col-xs-12 col-md-3 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            NO<br/>
                            UPFRONT COSTS
                        </p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-3 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            NO<br/>
                            MINIMUM ORDER
                        </p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-3 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            FREE<br/>
                            SHIPPING
                        </p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-3 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            FREE PERSONALIZED
                            <br/>
                            MARKETING SAMPLE!
                        </p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            SELECT YOUR BRICK FROM A
                            RANGE OF COLORS.
                        </h6>
                        <p>
                            Bricks are best-suited for in-ground
                            applications such as walkways, plazas, parks,
                            patios, and more.
                            Once you select your color, request your
                            <strong>Free Personalized Marketing Sample!</strong>
                        </p>
                        <ul class="body-area-list">
                            <li><span>Two Standard Sizes - 4” x 8” and 8” x 8”</span></li>
                            <li><span>Mesabi Granite in 12” x 12” Only</span></li>
                            <li><span>Rated for Pedestrian &amp; Light Vehicular Traffic</span></li>
                        </ul>
                        <p>
                            <router-link to="/pricing-guide" tag="button" class="learn-more-button">
                                <span>VIEW BRICK PRICING HERE</span>
                            </router-link>
                        </p>
                    </div>
                    <div class="body-area-right">
                        <div class="product-guide-map">
                            <img width="450" height="599" class="img-responsive" src="images/Product-Guide/engravedbricks01.png" alt="">
                            <router-link tag="a" to="/virtual/claret-full-range-brick" class="claret-full-range-brick"/>
                            <router-link tag="a" to="/virtual/landmark-gray-brick" class="landmark-gray-brick"/>
                            <router-link tag="a" to="/virtual/regimental-red-brick" class="regimental-red-brick"/>
                            <router-link tag="a" to="/virtual/medium-ironspot-brick" class="medium-ironspot-brick"/>
                            <router-link tag="a" to="/virtual/mesabi-granite-brick" class="mesabi-granite-brick"/>
                        </div>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <div class="product-guide-map">
                            <img width="450" height="401" class="img-responsive" src="images/Product-Guide/engravedbricks02.png" alt="">
                            <router-link tag="a" to="/virtual/red-blend-tile" class="red-blend-tile"/>
                            <router-link tag="a" to="/virtual/medium-ironspot-tile" class="medium-ironspot-tile"/>
                            <router-link tag="a" to="/virtual/manganese-tile" class="manganese-tile"/>
                            <router-link tag="a" to="/virtual/absolute-black-granite-tile" class="absolute-black-granite-tile"/>
                        </div>
                    </div>
                    <div class="body-area-right">
                        <h6 class="body-area-headline">
                            SELECT YOUR TILE FROM A
                            RANGE OF COLORS.
                        </h6>
                        <p>
                            Tiles are best suited for vertical installations,
                            such as walls, partitions, seat walls, columns,
                            indoor and outdoor use.
                            Once you select your color, request your
                            <strong>Free Personalized Marketing Sample!</strong>
                        </p>
                        <ul class="body-area-list">
                            <li><span>Two Standard Sizes - 4”&nbsp;x&nbsp;8” &amp; 8”&nbsp;x&nbsp;8”</span></li>
                            <li><span>Absolute Black Granite in 12”&nbsp;x&nbsp;12” Only</span></li>
                        </ul>
                        <p>
                            <router-link to="/pricing-guide" tag="button" class="learn-more-button">
                                <span>VIEW TILE PRICING HERE</span>
                            </router-link>
                        </p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            OFFER A KEEPSAKE BRICK
                            OR TILE TO YOUR DONORS.
                        </h6>
                        <p>
                            Keepsake Replicas are an additional fundraising
                            item that offer donors a display piece for their
                            home or office.
                        </p>
                        <ul class="body-area-list">
                            <li><span>Replicas are a duplicate of the installed brick</span></li>
                            <li><span>Hand-crafted using the same size, material and message</span></li>
                            <li><span>Add a plaque to your replica to commemorate your project</span></li>
                        </ul>
                        <p>
                            <router-link to="/pricing-guide" tag="button" class="learn-more-button">
                                <span>VIEW REPLICA &amp; PLAQUE PRICING HERE</span>
                            </router-link>
                        </p>
                    </div>
                    <div class="body-area-right">
                        <img width="450" height="401" class="img-responsive" src="images/Product-Guide/engravedbricks03.png" alt="">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <img width="450" height="439" class="img-responsive" src="images/Product-Guide/engravedbricks04.png" alt="">
                    </div>
                    <div class="body-area-right">
                        <h6 class="body-area-headline">
                            SELECT THE FONT STYLE THAT’S
                            RIGHT FOR YOUR PROJECT.
                        </h6>
                        <p>
                            All inscriptions, regardless of font, are engraved
                            in all uppercase, and centered vertically and
                            horizontally.
                        </p>
                        <ul class="body-area-list">
                            <li><span>Frutiger - 16 Characters per line</span></li>
                            <li><span>Univers - 20 Characters per line</span></li>
                        </ul>
                        <div class="frl-recommended">
                            <img width="55" height="58" src="images/recommendedicon.png" alt="">
                            <span>Frutiger is recommended for its quality engraving and is our most popular font.</span>
                        </div>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            ADD UNIQUE PERSONALIZATION
                            OPTIONS, SUCH AS SYMBOLS
                            AND LOGOS TO FURTHER
                            CUSTOMIZE YOUR PROJECT.
                        </h6>
                        <p>
                            Select from the following options;
                        </p>
                        <ul class="body-area-list">
                            <li><span>Small &amp; Large Symbols</span></li>
                            <li><span>Greek Characters</span></li>
                            <li><span>Project Logos</span></li>
                            <li><span>Donor Logos</span></li>
                        </ul>
                        <p>
                            <router-link to="/pricing-guide" tag="button" class="learn-more-button">
                                <span>VIEW SYMBOL &amp; LOGO PRICING HERE</span>
                            </router-link>
                        </p>
                    </div>
                    <div class="body-area-right">
                        <img width="450" height="373" class="img-responsive" src="images/Product-Guide/engravedbricks05.png" alt="">
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    // import ImageMap from 'image-map';
    export default {
        name: 'product-guide',
        components: {
        },
        metaInfo: {
            title: 'Product Guide',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: ''
                }
            ]
        },
        mounted: function () {
            // window.$('img[usemap]').imageMap();
            // console.log($('img[usemap]'));
            // var im = ImageMap('img[usemap]');
            // console.log(im);
        },
        beforeDestroy: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// ProductGuide.vue?14206e08